import type { BinderSection } from "modules/binder/model/binder";
import { TradeListType } from "modules/tradeLists/model/tradeList";

export function binderSectionForTradeListType(
  type: TradeListType
): Extract<BinderSection, "haves" | "wants"> {
  return type === TradeListType.WANTS ? "wants" : "haves";
}

interface BinderListPathOptions {
  import?: boolean;
  query?: string;
  view?: "history";
  step?: string;
  importId?: string;
}

/**
 * Builds Binder destinations for code that cannot access the runtime facet
 * serializer (plain model helpers and compatibility routes). UI components
 * should prefer serializeBinderParams so default values stay canonical.
 */
export function getBinderListPath(
  listId: string,
  type: TradeListType,
  options: BinderListPathOptions = {}
) {
  const params = new URLSearchParams({
    section: binderSectionForTradeListType(type),
    list: listId,
  });

  if (options.query) params.set("q", options.query);
  if (options.view) params.set("view", options.view);
  if (options.step) params.set("step", options.step);
  if (options.importId) params.set("importId", options.importId);

  return `/x/binder${options.import ? "/import" : ""}?${params.toString()}`;
}
